/**
 * Will this campaign send by itself, or does a person have to approve it?
 *
 * Smart SMS content is generated by a model and parked in the Review Queue
 * until a human approves it. Nothing in the creation flow said so: you
 * filled in the form, saw "Program created!", and reasonably believed you
 * were finished. The campaign then sat waiting for an approval nobody knew
 * to give.
 *
 * Mirrors SchedulerService._requires_review. The two are checked against
 * each other by tests/unit/test_approval_is_visible.py -- if the backend
 * changes which types are gated and this does not, the UI starts telling
 * people the opposite of what will happen.
 */

/** Campaign types whose generated content waits for a human. */
export const REVIEW_BY_DEFAULT = ['sms_direct', 'smart_sms', 'bulk_voice'];

/** Programme types that send as soon as they run, whatever their channels. */
export const DIRECT_FIRE_PROGRAM_TYPES = ['elevenlabs_ivr', 'multi'];

export function requiresApproval(campaignType, config = {}) {
  const override = config?.requires_review;
  if (typeof override === 'boolean') return override;
  const type = String(campaignType || '').trim().toLowerCase();
  if (DIRECT_FIRE_PROGRAM_TYPES.includes(type)) return false;
  return REVIEW_BY_DEFAULT.includes(type);
}

/**
 * What to tell the person before they create it, in plain words.
 * `null` when there is nothing surprising to say.
 */
export function approvalNotice(campaignType, config = {}) {
  if (!requiresApproval(campaignType, config)) return null;
  return {
    title: 'This campaign needs your approval before anything is sent',
    body: 'Each time it runs, the generated messages wait in the Review Queue. '
        + 'Nothing reaches a patient until someone approves them there.',
    href: '/review-queue',
    linkLabel: 'Open Review Queue',
  };
}
